import { AG_CELL } from "@platform/btx-grid-components";

/** Attributes a reviewable rate cell carries so a right-click can name the cell it landed on. */
export const RATE_REVIEW_PLAN_ID_ATTR = "data-rate-review-plan-id";
export const RATE_REVIEW_PATH_ATTR = "data-rate-review-path";

export interface RateReviewTarget {
  planId: string;
  fieldPath: string;
}

const RATE_REVIEW_CELL_SELECTOR = `[${RATE_REVIEW_PATH_ATTR}]`;

const readRateReviewTarget = (cell: Element): RateReviewTarget | undefined => {
  const planId = cell.getAttribute(RATE_REVIEW_PLAN_ID_ATTR);
  const fieldPath = cell.getAttribute(RATE_REVIEW_PATH_ATTR);

  return planId && fieldPath ? { planId, fieldPath } : undefined;
};

/**
 * Resolves the rate cell under a pointer event.
 *
 * The rates grid holds one AG Grid cell per plan and draws the whole rate table
 * inside it, so AG Grid's own column and row only ever resolve to the plan. The
 * event target is the only thing that names the individual cell.
 */
export const resolveRateReviewTarget = (
  eventTarget: EventTarget | null,
): RateReviewTarget | undefined => {
  if (!(eventTarget instanceof Element)) {
    return undefined;
  }

  const cell = eventTarget.closest(RATE_REVIEW_CELL_SELECTOR);

  return cell ? readRateReviewTarget(cell) : undefined;
};

export const resolvePlanRateReviewTargets = (
  eventTarget: EventTarget | null,
): RateReviewTarget[] => {
  if (!(eventTarget instanceof Element)) {
    return [];
  }

  const planCell = eventTarget.closest(AG_CELL);
  if (!planCell) {
    return [];
  }

  return Array.from(
    planCell.querySelectorAll(RATE_REVIEW_CELL_SELECTOR),
  ).flatMap((cell) => {
    const target = readRateReviewTarget(cell);
    return target ? [target] : [];
  });
};
